import { IObject } from '@common/typings/global';
import { T_Storage_Value } from '@common/typings/cache';
import { isJsonString, isObject } from './common';
import { useSerializer } from './serializer';

interface TMsStorage {
  get: (key: string) => any;
  set: (key: string, value: T_Storage_Value) => void;
  remove: (key: string) => void;
  removeAll: (keys: string[]) => void;
  setObject: (keyValues: IObject) => void;
}

const noStorageLog = (key) => {
  // 借款流程存储的key，若未获取到上报日志。借款页、快捷借款页全量切完后删除
  const loanUseKeys = [
    'loanFailureReasonDescription',
    'arbitrationAllDataToCash',
    'isShowZhonganText',
    'loanCutToInsure',
    'zyReduceStrategyData',
    'hasOcr',
    'hasContacts',
    'hasface',
    'checkAuthProtocol',
    'loanFrontImgBase64',
    'loanBackImgBase64',
    'kycAbResult',
    'needAddContactNum',
    'arbitrationAllData',
    'msInterestRate',
    'zyReduceStrategy',
    'msInsuInterestRate',
    'msGuaranteeNbr',
    'FLAGDISPAYARBITRATION',
    'fundPlanCode',
    'insureWhetherSign',
    'allFundSign',
    'allFundModel',
    'PROTOCOLLISTS',
    'GROUPROUTEINFO',
    'UNIONROUTENO',
    'preInsureName',
    'insureWhetherSign',
    'allFundSign',
    'allFundModel',
    'unUnionLoanRouteNo',
    'x48ProtocolObj',
    'submitMoneyVal',
    'delaySubmitNo',
    'LOANGPSCONTRACTNO',
    'LOANGPSREFNBR',
    'insureBankMobile',
    'oanJumpToCheckFace',
    'transactionPasswordTest',
    'LOANBANKINFO',
  ];
  if (loanUseKeys.includes(key)) {
    window.REPORT_TRACK('web_error_log', {
      fail_reason: '获取storage失败：' + key,
    });
  }
};

// 获取localStorage中信息，如存有string则自动检测转换为Json
export const msLocalStorage: TMsStorage = {
  get: (key) => {
    if (localStorage.getItem(key) === null) {
      noStorageLog(key);
    }
    if (localStorage.getItem(key) === 'undefined' || localStorage.getItem(key) === 'null')
      return null;

    // 是否为object类型
    if (isJsonString(localStorage.getItem(key))) {
      return JSON.parse(<string>localStorage.getItem(key));
    }

    // 是否为boolean
    if (localStorage.getItem(key) === 'true' || localStorage.getItem(key) === 'false') {
      return JSON.parse(<string>localStorage.getItem(key));
    }

    return localStorage.getItem(key);
  },
  set: (key, value) => {
    const serializer = useSerializer('write', value);
    if (serializer) {
      localStorage.setItem(key, serializer(value));
      return;
    }
    // 如果是对象类型，加JSON.stringify
    if (!isJsonString(value)) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, <string>value);
    }
  },
  setObject: (keyValues: IObject) => {
    Object.keys(keyValues)?.forEach((item) => msLocalStorage.set(item, keyValues[item]));
  },
  remove: (key: string) => {
    localStorage.removeItem(key);
  },
  removeAll: (keys: string[]) => {
    keys.forEach((item) => localStorage.removeItem(item));
  },
};

// 同上，后面可增加delete方法
export const msSessionStorage: TMsStorage = {
  get: (key) => {
    if (sessionStorage.getItem(key) === null) {
      noStorageLog(key);
    }

    if (sessionStorage.getItem(key) === 'undefined' || sessionStorage.getItem(key) === 'null')
      return null;

    // 是否为object类型
    if (isJsonString(sessionStorage.getItem(key))) {
      return JSON.parse(<string>sessionStorage.getItem(key));
    }

    // 是否为boolean
    if (sessionStorage.getItem(key) === 'true' || sessionStorage.getItem(key) === 'false') {
      return JSON.parse(<string>sessionStorage.getItem(key));
    }

    return sessionStorage.getItem(key);
  },
  set: (key, value) => {
    const serializer = useSerializer('write', value);
    if (serializer) {
      sessionStorage.setItem(key, serializer(value));
      return;
    }
    // 如果是对象类型，加JSON.stringify
    if (isObject(value)) {
      sessionStorage.setItem(key, JSON.stringify(value));
    } else {
      sessionStorage.setItem(key, <string>value);
    }
  },
  remove: (key: string) => {
    sessionStorage.removeItem(key);
  },
  removeAll: (keys: string[]) => {
    keys.forEach((item) => sessionStorage.removeItem(item));
  },
  setObject: (keyValues: IObject) => {
    Object.keys(keyValues)?.forEach((item) => msSessionStorage.set(item, keyValues[item]));
  },
};
